import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-900" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6" data-id="element-14">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-15">
          <div className="text-center md:text-left" data-id="element-16">
            <h3 className="text-white font-bold text-xl mb-2" data-id="element-17">
              Lighthouse HRAI Consulting
            </h3>
            <p className="text-sm max-w-md" data-id="element-18">
              AI Consulting for Hiring in Small Businesses. Serving small
              businesses looking to implement AI in recruitment, hiring
              automation, and HR processes.
            </p>
          </div>

          <div className="text-sm" data-id="element-19">
            &copy; {new Date().getFullYear()} Lighthouse HRAI Consulting. All
            rights reserved.
          </div>
        </div>
      </div>
    </footer>;
}